/**
 * Utility to manage connection flow states and prevent interference
 * between user-initiated flows and auto-reconnection logic
 */

export class ConnectionFlowState {
  private static isUserFlowActive = false;
  private static flowStartTime: number | null = null;
  private static readonly FLOW_TIMEOUT = 5 * 60 * 1000; // 5 minutes

  /**
   * Mark that a user-initiated flow is starting
   * This prevents auto-reconnection from interfering
   */
  static startUserFlow(flowType: 'connect' | 'callback' | 'disconnect'): void {
    this.isUserFlowActive = true;
    this.flowStartTime = Date.now();
    
    console.log(`[ConnectionFlowState] Starting ${flowType} flow`);
    
    // Auto-clear the flag after timeout to prevent permanent blocking
    setTimeout(() => {
      if (this.flowStartTime && Date.now() - this.flowStartTime >= this.FLOW_TIMEOUT) {
        this.endUserFlow();
        console.log('[ConnectionFlowState] Auto-cleared flow state due to timeout');
      }
    }, this.FLOW_TIMEOUT);
  }

  /**
   * Mark that the user flow has completed
   */
  static endUserFlow(): void {
    this.isUserFlowActive = false;
    this.flowStartTime = null;
    console.log('[ConnectionFlowState] Ended user flow');
  }

  /**
   * Check if a user flow is currently active
   */
  static isFlowActive(): boolean {
    // Auto-clear if expired
    if (this.flowStartTime && Date.now() - this.flowStartTime >= this.FLOW_TIMEOUT) {
      this.endUserFlow();
    }
    
    return this.isUserFlowActive;
  }

  /**
   * Check if auto-reconnection should be blocked
   */
  static shouldBlockAutoReconnection(): boolean {
    const isUserFlow = this.isFlowActive();
    const urlParams = new URLSearchParams(window.location.search);
    const isCallbackInProgress = urlParams.has('institution') || urlParams.has('code') || urlParams.has('state');
    const isOnConnectPage = window.location.pathname.includes('/investments/connect');
    
    return isUserFlow || isCallbackInProgress || isOnConnectPage;
  }
}